import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'tr-video-resume',
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './tr-video-resume.component.html',
    styleUrls: ['./tr-video-resume.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TrVideoResumeComponent {

    @Input() public title: string;
    @Input() public showContentDescription: boolean;
    @Output() public onCloseClick: EventEmitter<boolean> = new EventEmitter();
    @Output() public onOverlayClick: EventEmitter<boolean> = new EventEmitter();

    public visible: boolean;
    public showPlayButton: boolean = true;

    public close(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.onCloseClick.emit(true);
    }

    public onOverlayClickHandler(event: Event) {
        event.preventDefault();
        this.onOverlayClick.emit(true);
    }

    public show(showPlayButton: boolean = true, showContentDescription: boolean = true) {
        this.showPlayButton = showPlayButton;
        this.showContentDescription = showContentDescription;
        this.visible = true;
    }

    public hide() {
        this.visible = false;
    }
}
